import { useSelectFilter } from '@/domain/prices/filters/hooks';
import { SelfDriveSelector } from './SelfDriveSelector';
import { FlightSelector } from './FlightSelector';
import { BusSelector } from './BusSelector';

export const TransportSelector = () => {
  const { selectedValue } = useSelectFilter('TransportType');

  if (!selectedValue) {
    return null;
  }
  if (selectedValue === 'Bus') {
    return <BusSelector />;
  }
  if (selectedValue === 'Flight') {
    return <FlightSelector />;
  }
  if (selectedValue === 'SelfDrive') {
    return <SelfDriveSelector />;
  }
};
